import { mockPermissionsSumoQuery } from '@sbu/views.nav/build/mocks';

export const handlers = [
  mockPermissionsSumoQuery((_req, res, ctx) => {
    return res(
      ctx.delay(1500), // mock loading state
      ctx.data({
        currentUserSumo: {
          id: '114109343',
          permissions: [
            'perm/capability/dataVolume',
            'perm/capability/cloudSoarIncidentFoldersEdit',
            'perm/capability/ipAllowlisting',
            'perm/capability/cseCommentOnInsights',
            'perm/capability/viewDataStreams',
            'perm/capability/cseDeleteInsights',
            'perm/collector/readCollectors',
            'perm/capability/cloudSoarCustomizationIncidentLabels',
            'perm/capability/viewMonitorsV2',
            'perm/capability/cloudSoarAPIEmailEdit',
            'perm/capability/managePartitions',
            'perm/capability/cseViewMatchLists',
            'perm/capability/cloudSoarIncidentEdit',
            'perm/capability/manageDeletionRules',
            'perm/capability/manageThreatIntelDataStore',
            'perm/capability/cseManageActions',
            'perm/capability/manageOpenAnalyticsEndpoint',
            'perm/capability/cseManageCustomInsightStatuses',
            'perm/capability/createAccessKeys',
            'perm/capability/cloudSoarAppCentralAccess',
            'perm/capability/worldDashboardMaster',
            'perm/capability/cseViewSuppressedEntities',
            'perm/capability/viewSlos',
            'perm/collector/manageCollectors',
            'perm/capability/cseManageTagSchemas',
            'perm/capability/cseViewContextActions',
            'perm/capability/manageContent',
            'perm/capability/cseManageEntityCriticality',
            'perm/capability/cseManageEntity',
            'perm/capability/cloudSoarIncidentTriageEdit',
            'perm/capability/fieldExtraction',
            'perm/capability/cseManageInsightSignals',
            'perm/capability/cloudSoarIncidentNotesAccess',
            'perm/capability/cloudSoarCustomizationIncidentReports',
            'perm/capability/cloudSoarWidgetsAll',
            'perm/capability/cloudSoarIncidentTriageBulkPhysicalDelete',
            'perm/capability/cloudSoarIncidentTaskReassign',
            'perm/capability/cloudSoarKPIUse',
            'perm/capability/cloudSoarIncidentBulkPhysicalDelete',
            'perm/capability/manageEntityTypeConfig',
            'perm/capability/cloudSoarIncidentAttachmentsEdit',
            'perm/capability/cloudSoarNotificationConfigure',
            'perm/capability/cloudSoarAutomationRulesConfigure',
            'perm/capability/cloudSoarGlobalSearchUse',
            'perm/capability/metricsRules',
            'perm/capability/cloudSoarReportAccess',
            'perm/capability/cloudSoarUserManagementQueues',
            'perm/capability/cloudSoarNotificationTriage',
            'perm/capability/cloudSoarIncidentQueuesChangeOwnership',
            'perm/capability/cseViewFileAnalysis',
            'perm/capability/cloudSoarAutomationRulesAccess',
            'perm/capability/cloudSoarGeneralConfigure',
            'perm/capability/cseViewCustomInsightStatuses',
            'perm/capability/cseManageNetworkBlocks',
            'perm/capability/cseManageEntityGroups',
            'perm/capability/cseManageCustomInsights',
            'perm/capability/cloudSoarIncidentAccess',
            'perm/capability/cseManageCustomEntityType',
            'perm/capability/viewThreatIntelDataStore',
            'perm/capability/cseManageEntityConfiguration',
            'perm/capability/manageDataStreams',
            'perm/capability/cseManageArtifacts',
            'perm/capability/manageNamedActions',
            'perm/capability/cloudSoarIncidentChangeOwnership',
            'perm/capability/cloudSoarAuditAndInformationConfigureAuditTrail',
            'perm/capability/cloudSoarIncidentTaskEdit',
            'perm/capability/manageMonitorsV2',
            'perm/capability/cseViewThreatIntelligence',
            'perm/capability/cloudSoarIncidentTemplatesAccess',
            'perm/capability/supportAccount',
            'perm/capability/cloudSoarObservabilityAccess',
            'perm/capability/cloudSoarIncidentTriageChangeOwnership',
            'perm/capability/cloudSoarReportAll',
            'perm/capability/cloudSoarIncidentWarRoomUse',
            'perm/capability/cloudSoarAuditAndInformationLicenseInformation',
            'perm/capability/cseManageFavoriteFields',
            'perm/capability/cseViewEntityCriticality',
            'perm/capability/viewParsers',
            'perm/capability/viewPartitions',
            'perm/capability/cseManageInsightAssignee',
            'perm/capability/cloudSoarObservabilityManagement',
            'perm/capability/cloudSoarIncidentQueuesUse',
            'perm/capability/manageIndexes',
            'perm/capability/viewCse',
            'perm/capability/cseManageInsightPolicy',
            'perm/capability/viewFields',
            'perm/capability/cloudSoarDashboardAccess',
            'perm/capability/cseViewActions',
            'perm/capability/cloudSoarCustomizationLogo',
            'perm/capability/cloudSoarEntitiesAccess',
            'perm/capability/cloudSoarBridgeMonitoringAccess',
            'perm/capability/cseViewNetworkBlocks',
            'perm/capability/cseViewActionConfiguration',
            'perm/capability/viewFieldExtraction',
            'perm/capability/cseManageSuppressedEntities',
            'perm/capability/manageConnections',
            'perm/capability/cseManageContextActions',
            'perm/capability/cseManageThreatIntelDataStore',
            'perm/capability/cloudSoarIncidentPlaybooksManage',
            'perm/capability/dataForwarding',
            'perm/capability/cseViewEntity',
            'perm/capability/manageBudgets',
            'perm/capability/cloudSoarEntitiesManage',
            'perm/capability/viewMutingSchedules',
            'perm/capability/manageSlos',
            'perm/capability/manageScheduledViews',
            'perm/capability/manageMutingSchedules',
            'perm/capability/cloudSoarIncidentTemplatesConfigure',
            'perm/capability/viewDeletionRules',
            'perm/capability/cloudSoarIncidentTaskAccessAll',
            'perm/capability/cloudSoarIncidentTaskAccess',
            'perm/capability/metricsTransformation',
            'perm/capability/accessKeys',
            'perm/capability/cloudSoarIncidentNotesEdit',
            'perm/capability/orgSettings',
            'perm/capability/cloudSoarUserManagementGroups',
            'perm/capability/cloudSoarPlaybooksAccess',
            'perm/capability/cloudSoarIncidentTriageView',
            'perm/capability/worldDashboards',
            'perm/capability/manageTokens',
            'perm/capability/manageApps',
            'perm/capability/cseManageInsightStatus',
            'perm/capability/cloudSoarIncidentTriageAccessAll',
            'perm/capability/cseManageAutomations',
            'perm/capability/searchAuditIndex',
            'perm/capability/cseViewEntityGroups',
            'perm/capability/saml',
            'perm/capability/cseViewRules',
            'perm/capability/cseInvokeInsights',
            'perm/capability/cseManageMatchLists',
            'perm/capability/cloudSoarEntitiesBulkPhysicalDelete',
            'perm/capability/cseExecuteAutomations',
            'perm/capability/cloudSoarIncidentView',
            'perm/capability/auditEventIndex',
            'perm/capability/cloudSoarIncidentTaskView',
            'perm/capability/cseViewEntityConfiguration',
            'perm/capability/cseManageEnrichments',
            'perm/capability/passwordPolicy',
            'perm/capability/ipWhitelisting',
            'perm/capability/cseViewCustomEntityType',
            'perm/capability/metricsExtraction',
            'perm/capability/cseManageThreatIntelligence',
            'perm/capability/cseManageFileAnalysis',
            'perm/capability/cseViewMappings',
            'perm/capability/cseViewEnrichments',
            'perm/capability/cloudSoarIncidentTriageAccess',
            'perm/capability/cloudSoarDashboardAll',
            'perm/capability/cloudSoarIntegrationsAccess',
            'perm/capability/cloudSoarAPIUse',
            'perm/capability/cseViewAutomations',
            'perm/capability/cseManageInsightTags',
            'perm/capability/cloudSoarAppCentralExport',
            'perm/capability/changeDataAccessLevel',
            'perm/capability/shareDashboardAllowlist',
            'perm/capability/viewAlerts',
            'perm/capability/cloudSoarKPIConfigure',
            'perm/capability/manageFields',
            'perm/capability/manageUsersAndRoles',
            'perm/capability/viewScheduledViews',
            'perm/capability/downloadSearchResults',
            'perm/capability/cloudSoarIncidentAttachmentsAccess',
            'perm/capability/cloudSoarIntegrationsConfigure',
            'perm/capability/cseManageMappings',
            'perm/capability/cseViewTagSchemas',
            'perm/capability/cloudSoarAuditAndInformationAuditTrail',
            'perm/capability/viewAccountOverview',
            'perm/capability/cloudSoarCustomizationFields',
            'perm/capability/viewConnections',
            'perm/capability/cseViewThreatIntelDataStore',
            'perm/capability/cloudSoarIncidentPlaybooksEdit',
            'perm/capability/cloudSoarARKConfigure',
            'perm/capability/cloudSoarARKManage',
            'perm/capability/cloudSoarIncidentBulkOperations',
            'perm/capability/cseManageRules',
            'perm/capability/cloudSoarPlaybooksConfigure',
            'perm/capability/audit',
            'perm/capability/cloudSoarAPIAdmin',
            'perm/capability/cloudSoarIncidentPlaybooksAccess',
            'perm/capability/adminMonitorsV2',
            'perm/capability/dataVolumeIndex',
            'perm/capability/cloudSoarIncidentManageInvestigators',
            'perm/capability/whitelistDashboards',
            'perm/capability/cloudSoarIncidentReportAccess',
            'perm/capability/cseCreateInsights',
            'perm/capability/cloudSoarIncidentAccessAll',
            'perm/capability/viewNamedActions',
            'perm/capability/viewCloudSoar',
            'perm/capability/cseViewCustomInsights',
            'perm/capability/cloudSoarAPIEmailRead',
          ],
          __typename: 'CurrentUserSumo',
        },
      })
    );
  }),
];
